import { PagedList } from "@shared/list/paged-list";
import { BaseApiResponse, PaginationListRequest } from "../common";

export class ListEInvoiceBankAccountRequest extends PaginationListRequest {}
export interface EInvoiceBankAccountListModel
  extends PagedList<EInvoiceBankAccountDto> {}
export interface EInvoiceBankAccountDto {
  Id: number;
  UserId: number;
  Iban: string;
  Bic: string;
  Title: string;
  Label: string;
}

export class AddBankAccountRequest {
  Iban: string;
  Bic: string;
  Title: string;
  Label: string;
}

export class EditBankAccountRequest {
  Iban: string;
  Bic: string;
  Title: string;
  Label: string;
}

export interface DeleteBankAccountRequest {
  ForceDelete: boolean;
}

export interface DeleteBankAccountResponse
  extends BaseApiResponse<DeleteBankAccountError> {
  AttachedInvoiceCount: number | null;
}

export interface AddBankAccountResponse
  extends BaseApiResponse<CreateBankAccountError> {
  BankAccount: EInvoiceBankAccountDto | null;
}

export interface EditBankAccountResponse
  extends BaseApiResponse<EditBankAccountError> {
  BankAccount: EInvoiceBankAccountDto | null;
}

export enum EditBankAccountError {
  NotFound = 1,
  Dupplicate = 2,
}
export enum CreateBankAccountError {
  Dupplicate = 1,
}

export enum DeleteBankAccountError {
  NotFound = 1,
  AttachedInvoice = 2,
}
